import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';

import { DynamicFieldsService } from '../dynamic-fields.service';

@Component({
    selector: 'dynfield-button-ddown-select',
    template: require('./button-ddown-select.component.html')
})
export class DynamicFieldButtonDdownSelectComponent implements OnInit, OnChanges {
    @Input() fieldId: string;
    @Input() fieldData: any;
    @Output() fieldDataChange = new EventEmitter<any>();
    @Input() fieldDataIdOnly: boolean = false;
    @Input() fieldOptions: any;
    @Input() currentSelection: string;
    @Input() fieldError: any;
    @Input() allowUpdate: boolean;
    @Input() showLabel: boolean;
    @Input() classes: string;

    public isRequired: boolean;
    public error: any;
    public selectedElement: any;

    constructor(private dynamicFieldsService: DynamicFieldsService) {}

    ngOnInit(): void {
        this.isRequired = this.dynamicFieldsService.isRequired(this);
        this.selectedElement = this.getSelectedElement(this.fieldData);

        if (_.isEmpty(this.selectedElement)) {
            this.selectedElement = _.find(this.fieldOptions.fieldElements, { defaultSelected: true });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('fieldError' in changes) {
            this.error = this.dynamicFieldsService.setError(changes.fieldError.currentValue, this.fieldData);
        }
    }

    clearError(): void {
        this.error = null;
    }

    setSelectedElement(element: any): void {
        this.selectedElement = element;
        this.fieldData = (this.fieldDataIdOnly) ? this.selectedElement?.id : element;
        this.fieldDataChange.emit(this.fieldData);
        this.clearError();
    }

    setStyle(): Object {
        if (!_.has(this.fieldOptions, 'containerStyling') || 
            (_.has(this.fieldOptions, 'containerStyling') && this.fieldOptions.containerStyling)) {
            return { 
                "margin-left": "15px",
                "border-bottom": "solid 1px #999",
                "padding-bottom": ".75em;"
            };
        } else {
            return {};
        }
    }

    private getSelectedElement(element: any): any {
        const id = (_.isObject(element)) ? _.get(element, 'id') : element;
        const selector: any = id ?
            { id: id } :
            { defaultSelected: true }
        ;
        const ret = _.find(this.fieldOptions.fieldElements, selector);

        // Default value in case nothing is found
        // Prevents spinning JS errors in angular render.
        const def = _.get(this.fieldOptions, 'fieldElements.length', 0) ?
        this.fieldOptions.fieldElements[0] :
        {
            label: '',
            bgColorClass: ''
        };

        return ret ?? def;
    }

    trackElementById(index: number, element: any): any {
        return element.id;
    }
}
